var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography, Button } from '@mui/material';
var FIGMA_BUTTON_WIDTH = 212;
export var HeaderCTACard = function (_a) {
    var title = _a.title, buttonText = _a.buttonText, buttonOnClick = _a.buttonOnClick, imageUrl = _a.imageUrl;
    return (_jsxs(Box, { sx: containerSx, children: [_jsxs(Box, { sx: contentContainerSx, children: [_jsx(Typography, { sx: titleSx, children: title }), _jsx(Button, { hierarchy: "Secondary gray", size: "md", onClick: buttonOnClick, sx: buttonSx, children: buttonText })] }), _jsx(Box, { component: "img", src: imageUrl, alt: "header-cta-card", sx: imageContainerSx })] }));
};
var containerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        backgroundColor: backrs.colors['Colors/Foreground/fg-primary'],
        borderRadius: backrs.radius['radius-xl'],
        flexWrap: 'wrap',
        flexDirection: 'column',
    });
};
var contentContainerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: backrs.spacing['spacing-xl'],
        paddingTop: {
            xs: backrs.spacing['spacing-2xl'],
            sm: backrs.spacing['spacing-4xl'],
        },
        pl: {
            xs: backrs.spacing['spacing-2xl'],
            sm: backrs.spacing['spacing-6xl'],
        },
        pr: {
            xs: backrs.spacing['spacing-2xl'],
            sm: backrs.spacing['spacing-4xl'],
        },
    });
};
var titleSx = function (_a) {
    var _b;
    var typography = _a.typography, backrs = _a.backrs, breakpoints = _a.breakpoints;
    return (__assign(__assign({ color: backrs.colors['Colors/Base/White'] }, typography['display-md-semibold']), (_b = {}, _b[breakpoints.down('sm')] = __assign({}, typography['display-xs-semibold']), _b)));
};
var buttonSx = {
    width: {
        sm: "".concat(FIGMA_BUTTON_WIDTH, "px"),
    },
};
var imageContainerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        px: {
            xs: backrs.spacing['spacing-2xl'],
            sm: backrs.spacing['spacing-4xl'],
            md: backrs.spacing['spacing-9xl'],
        },
        pb: backrs.spacing['spacing-2xl'],
        pt: backrs.spacing['spacing-lg'],
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-end',
        margin: 'auto',
        pointerEvents: 'none',
        objectFit: 'contain',
        width: '100%',
        height: 'auto',
    });
};
